module.exports = __webpack_public_path__ + "static/media/twint-logo.3c17fa4d.png";